import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {DomSanitizer, SafeResourceUrl, SafeStyle, Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {UntypedFormGroup} from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-video-conference',
    templateUrl: './conference.component.html',
    styleUrls: ['./conference.component.scss'],
    standalone: true,
    imports: [
        MatTooltip,
        NgIf,
        NgClass,
    ],
})
export class ConferenceComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  detailsUrl: string;
  gridHeight: SafeStyle;
  buttonSubmitPromise: Promise<boolean>;
  isLoading = false;
  hasError = false;
  submitted = false;
  changePasswordForm: UntypedFormGroup;
  zoomUrl: SafeResourceUrl;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              private notificationService: NotificationService,
              private sanitizer: DomSanitizer,
  ) {
    super(route, headerService, titleService, authService);

    this.zoomUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://zoom.us/j/7337417607?pwd=L21yTkcyOUdFZkpYck1Vc1VIc0dDZz09`);
  }

  async ngOnInit() {
    this.gridHeight = this.sanitizer.bypassSecurityTrustStyle('calc(100vh - 172px)');

    console.log('on init');
    await super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnChanges() {
    this.submitted = false;
    this.changePasswordForm.reset({});
  }
}
